<p-multiSelect
  [fluid]="true"
  [formControl]="control"
  [options]="selectItems"
  appPrimengMultiselect
  emptyMessage="Brak opcji do wyboru."
  placeholder="Wybierz wartość" />
